import { signOut, signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebase-config';

export const logout = async () => {
  try {
    await signOut(auth);
    localStorage.removeItem('token');
    window.location.href = '/login';
  } catch (error) {
    console.error('Logout error:', error);
  }
};

export const login = async (email: string, password: string) => {
  try {
    const result = await signInWithEmailAndPassword(auth, email, password);
    return result;
  } catch (error) {
    console.error('Login error:', error);
    throw error;
  }
};
